// extracted by mini-css-extract-plugin
export default {"trustedCard":"TrustedPartnerCard_trustedCard__UwE1c","trustedCardLogo":"TrustedPartnerCard_trustedCardLogo__12jSu","trustedCardTitle":"TrustedPartnerCard_trustedCardTitle__tUzeh"};